<script>
    export let user
</script>

<div
    style={`font-family: ${user.css.family}; font-size: ${user.css.fontSize}px; color: ${user.css.color}; text-transform: ${user.css.upperCase ? 'uppercase' : 'none'}; font-weight: ${user.css.fontWeight}; font-style: ${user.css.fontStyle === 'regular' ? 'normal' : user.css.fontStyle}; text-decoration:  ${user.css.underline ? 'underline' : 'none'}; `}
    class="transition-all text-shadow duration-500 ease-in-out transform origin-center">
    {user.username}
</div>

<style>
    .text-shadow {
        text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.8);
    }

    .text-shadow-md {
        text-shadow: 0 4px 8px rgba(0, 0, 0, 0.12),
            0 2px 4px rgba(0, 0, 0, 0.08);
    }

    .text-shadow-lg {
        text-shadow: 0 15px 30px rgba(0, 0, 0, 0.11),
            0 5px 15px rgba(0, 0, 0, 0.08);
    }

    .text-shadow-none {
        text-shadow: none;
    }
</style>
